<template>
  <div class="circle">
    <div class="quadrant top-left" :style="colorForPart(4)" />
    <div class="quadrant top-right" :style="colorForPart(1)" />
    <div class="quadrant bottom-left" :style="colorForPart(3)" />
    <div class="quadrant bottom-right" :style="colorForPart(2)" />
    <div v-if="lucasMode" class="lucasMode" />
  </div>
</template>

<script setup lang="ts">
import { type PropType } from "vue";
import { TaskStatus } from "@/graphql";
import isModifierSet from "@/functions/userModifier";
import { ModifierType } from "@/functions/userModifierEnum";

const props = defineProps({
  status: {
    type: Number as PropType<TaskStatus>,
    required: true,
  },
  fillingColor: {
    type: String,
    default: undefined,
  },
});
const colorForPart = (part: number) => {
  if (props.fillingColor) {
    return `background-color: ${props.fillingColor};`;
  }
  if (props.status === TaskStatus.act) {
    return "background-color: var(--p-green-700);"; // "forestgreen";
  }
  if (part <= props.status) {
    return "background-color: var(--p-slate-800);";
  }
  return "background-color: white;";
};

const lucasMode = isModifierSet(ModifierType.lucasStatusMode);
</script>

<style lang="scss" scoped>
.circle {
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 1px solid var(--p-gray-500);
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
}
.quadrant {
  aspect-ratio: 1/1;
  width: 50%;
}
.quadrant:nth-child(1) {
  border-bottom: 1px solid var(--p-gray-500);
  border-right: 1px solid var(--p-gray-500);
}
.quadrant:nth-child(2) {
  border-bottom: 1px solid var(--p-gray-500);
  border-left: 1px solid var(--p-gray-500);
}
.quadrant:nth-child(3) {
  border-top: 1px solid var(--p-gray-500);
  border-right: 1px solid var(--p-gray-500);
}
.quadrant:nth-child(4) {
  border-top: 1px solid var(--p-gray-500);
  border-left: 1px solid var(--p-gray-500);
}

.lucasMode {
  position: absolute;
  background-color: white;
  width: 50%;
  height: 50%;
  inset: 25%;
  border: 1px solid var(--p-gray-500);
  border-radius: 50%;
}
</style>
